var map = {
	"./board/corner-bottom-left.png": 406,
	"./board/corner-bottom-right.png": 407,
	"./board/corner-top-left.png": 408,
	"./board/corner-top-right.png": 409,
	"./board/hole.png": 410,
	"./board/plank-bottom.png": 411,
	"./board/plank-left.png": 412,
	"./board/plank-right.png": 413,
	"./board/plank-top.png": 414,
	"./buttons/button-large-border.png": 415,
	"./buttons/button-medium-border.png": 416,
	"./buttons/button-nav-border.png": 417,
	"./flag/flag-normal.png": 418,
	"./flag/flag-ripped.png": 419,
	"./gems/border-default.png": 420,
	"./gems/broken-shadow.png": 421,
	"./gems/gem-blue.png": 422,
	"./gems/gem-bronze.png": 423,
	"./gems/gem-caviar.png": 424,
	"./gems/gem-gold.png": 425,
	"./gems/gem-ice.png": 426,
	"./gems/gem-lava.png": 427,
	"./gems/gem-neutral.png": 428,
	"./gems/gem-red.png": 429,
	"./gems/gem-silver.png": 430,
	"./gems/gem-void.png": 431,
	"./logo.png": 432,
	"./logo/logo-full.png": 433,
	"./panel/panel-border-bottom.png": 434,
	"./panel/panel-border-left.png": 435,
	"./panel/panel-border-right.png": 436,
	"./panel/panel-border-top.png": 437,
	"./round-button/round-button-bg-pressed.png": 438,
	"./round-button/round-button-bg.png": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;